const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');
const get = require('lodash.get');
const tracking = require('dibs-tracking');

const ContextComponent = require('../../../global/components/ContextComponent');
const contactDealerLauncher = require('../helpers/contactDealerLauncher');
const ViewInvoiceLink = require('../../../newPdp/components/Invoice/ViewInvoiceLink');

const style = require('../styles/RequestMoreInfoLinks.scss');
const copy = require('./requestMoreInfoLinksCopy.json');

const shouldShowHoldRequest = (item, user) => {
    return (
        !!item &&
        !get(item, 'hasRequestedHoldForBuyer') &&
        !get(item, 'isPriceUponRequest') &&
        !get(item, 'isOnHold') &&
        !get(item, 'isSold') &&
        !get(item, 'attributes.customizable[0].value') &&
        get(user, 'canUseNetPrice') &&
        get(item, 'isFurniture')
    );
};

const trackCTA = selection => {
    tracking.trackEvent({
        label: `contact link in pdp - more from dealer module|pre-populated submitted:${selection}`,
        category: 'contact dealer',
        action: 'contact dealer guided selection submitted',
    });

    tracking.trackEvent({
        label: 'contact link in pdp  - more from dealer module',
        category: 'contact dealer',
        action: 'contact dealer clicked',
    });
};

class RequestMoreInfoLinks extends ContextComponent {
    constructor() {
        super();
        this.requestHold = this.requestHold.bind(this);
        this.makeOffer = this.makeOffer.bind(this);

        this.openShippingQuoteModal = this.handleCtaClick.bind(this, {
            action: 'openShippingQuoteModal',
            selection: 'ask about shipping',
        });

        this.openConditionReportModal = this.handleCtaClick.bind(this, {
            action: 'openConditionReportModal',
            selection: 'request condition report',
        });
    }
    getLauncherProps() {
        const { item } = this.props;
        return {
            context: this.context,
            itemPk: get(item, 'serviceId'),
            dealerPk: get(item, 'seller.serviceId'),
        };
    }
    handleCtaClick(payload, event) {
        event.preventDefault();
        const { handleCtaClick } = this.props;
        handleCtaClick(payload);
        trackCTA(payload.selection);
    }
    requestHold(event) {
        event.preventDefault();
        const payload = Object.assign(this.getLauncherProps(), {
            currentStep: 'contactDealer',
            modalContentData: {
                isShowHoldRequest: false,
                isHoldRequestChecked: true,
                copySuffix: 'placeOnHold',
            },
        });

        contactDealerLauncher(payload);
        trackCTA('place item on hold');
    }
    makeOffer(event) {
        event.preventDefault();
        const payload = Object.assign(this.getLauncherProps(), {
            currentStep: 'makeOffer',
        });

        contactDealerLauncher(payload);
        trackCTA('make offer');
    }
    render() {
        const { hasUserId, userId, itemId, user, item } = this.props;
        const showRequestHold = shouldShowHoldRequest(item, user);
        const showMakeOffer = get(item, 'canBuyerMakeOffer', false);
        const showRequestShippingQuote = get(user, 'canRequestShippingQuote', false);

        return (
            <div>
                <div className="pdp-contact-instructions">{copy.header}</div>

                {showRequestShippingQuote && (
                    <a className={style.link} onClick={this.openShippingQuoteModal} href="#0">
                        {copy.requestShippingQuote}
                    </a>
                )}
                <a className={style.link} onClick={this.openConditionReportModal} href="#0">
                    {copy.requestConditionReport}
                </a>
                {showRequestHold && (
                    <a className={style.link} onClick={this.requestHold} href="#0">
                        {copy.requestToHoldItem}
                    </a>
                )}
                {showMakeOffer && (
                    <a className={style.link} onClick={this.makeOffer} href="#0">
                        {copy.makeOffer}
                    </a>
                )}
                <ViewInvoiceLink
                    className={style.link}
                    hasUserId={hasUserId}
                    userId={userId}
                    itemId={itemId}
                    user={user}
                    onClick={() => trackCTA('view invoice')}
                    children={copy.viewInvoice}
                />
            </div>
        );
    }
}

RequestMoreInfoLinks.propTypes = {
    hasUserId: PropTypes.bool.isRequired,
    user: PropTypes.object,
    item: PropTypes.object,
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    handleCtaClick: PropTypes.func,
};

module.exports = Relay.createContainer(RequestMoreInfoLinks, {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null,
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                canUseNetPrice: hasPermission(name: "B_NET_PRICE")
                canRequestShippingQuote: hasPermission(name: "B_REQUEST_SHIPPING_QUOTE")
            }
        `,
        item: () => Relay.QL`
            fragment on Item {
                serviceId
                isFurniture
                canBuyerMakeOffer(buyerId: $userId)
                hasRequestedHoldForBuyer(buyerId: $userId) @include(if: $hasUserId)
                isPriceUponRequest
                isOnHold
                isSold
                attributes {
                    customizable {
                        value
                    }
                }
                seller {
                    serviceId
                    sellerProfile {
                        company
                    }
                }
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/contact/dealer/components/RequestMoreInfoLinks.jsx